<template>
    <v-card v-if="infobox" height="fit-content" class="px-8 py-6 infobox-content">
      <p v-html="infoboxText" class="text-description">
        {{ infoboxText }}
      </p>
    </v-card>
</template>

<script>
export default {
  name: "InfoboxTooltip",
  data() {
    return {
      infoboxText: '',
      infobox: false,
    }
  },
  computed: {
  },
  methods: {
    open(infoboxText) {
      this.infobox = true;
      this.infoboxText = infoboxText;
    },
    close() {
      this.infobox = false;
    }
  }
}
</script>

<style scoped>
.infobox-content {
  position: absolute;
  width: 32vw;
  max-width: unset;
  -webkit-box-shadow: 5px 5px 20px var(--gray-color_4);
  -moz-box-shadow: 5px 5px 20px var(--gray-color_4);
  box-shadow: 5px 5px 20px var(--gray-color_4) !important;
  z-index: 99;
}
</style>